/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { IdpConfig } from '../config/auth.config';
import { BehaviorSubject, filter } from 'rxjs';
import { CommmonService } from 'src/app/utils/common.service';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IdpService {
  userProfile!: any;
  admin!: BehaviorSubject<boolean>;


  constructor(
    private readonly oauthService: OAuthService,
    private readonly commonService: CommmonService,
    private _router: Router
  ) {
    this.configure();
    this.admin = new BehaviorSubject<boolean>(false);
  }

  private configure() {
    this.oauthService.configure(IdpConfig);
    this.setupRouterSubscription();
  }

  private setupRouterSubscription() {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.handleNavigationEnd();
    });
  }

  private handleNavigationEnd() {
    const state = this._router.url;
    this.oauthService.loadDiscoveryDocumentAndLogin({ state })
      .then((value) => this.handleLoginResult(value));
    this.oauthService.setupAutomaticSilentRefresh();
  }

  private handleLoginResult(loginSuccess: boolean) {
    if (!loginSuccess) {
      return;
    }

    this.oauthService.loadUserProfile()
      .then((userProfile) => this.handleUserProfile(userProfile));
  }

  private handleUserProfile(userProfile: any) {
    this.handleStateNavigation();
    this.handleUrlNavigation();
    this.setUserProfile(userProfile);
  }

  private handleStateNavigation() {
    if (!this.oauthService.state) {
      return;
    }

    const state = decodeURIComponent(this.oauthService.state);
    this.navigateToStateUrl(state);
  }

  private navigateToStateUrl(state: string) {
    if (this.shouldRestoreRoute(state)) {
      this._router.navigateByUrl(state);
    }
  }
 
  private handleUrlNavigation() {
    const currentUrl = this._router.url;
    if (this.shouldRestoreRoute(currentUrl)) {
      this._router.navigateByUrl(currentUrl);
    }
  }

  private setUserProfile(userProfile: any) {
    this.commonService.setItemLocalStorage(
      'activeUser',
      JSON.stringify(userProfile),
    );
    this.userProfile = userProfile;
  }

  private shouldRestoreRoute(url: string): boolean {
    return url.startsWith('/') && this._router.url !== url;
  }

  logout() {
    this.userProfile = null;
    this.oauthService.logOut();
  }

  getUserProfile() {
    return this.userProfile;
  }

async loadUserProfileAsync(): Promise<any> {
  try {
    await this.oauthService.loadDiscoveryDocumentAndLogin();
    if (this.userProfile) {
      
      return this.userProfile;
    }
    const profile = await this.oauthService.loadUserProfile();
    
    if (profile) {
      this.setUserProfile(profile);
    }
    return profile;
  } catch (error) {
    console.error('Error en carga asíncrona de perfil:', error);
    return null;
  }
}
}
